import React, { Ref } from "react";
import { Media } from "../../../global";
import Image from "next/image";
import { getStrapiMedia } from "@/utils/api-helpers";
import { LazyLoadVid } from "../lazyLoadVid";

interface WorkApproach {
    title: string;
    description: string;
    description2: string;
    media: Media;
    mediaType: string;
    direction: string;
    icon: Media;
    index: number;
    iconRef1?: React.RefObject<HTMLImageElement>;
    iconRef2?: React.RefObject<HTMLImageElement>;
}

export default function WorkApproach({
    title,
    description,
    description2,
    media,
    mediaType,
    direction,
    icon,
    index,
    iconRef1,
    iconRef2,
}: WorkApproach) {
    return direction === "right" ? (
        <div className="relative flex flex-col md:flex-row justify-between items-center md:items-start md:w-max gap-8 md:space-x-[20.833vw]">
            <div className="mt-14 space-y-8 md:max-h-[400px]">
                <h5 className="text-cyan text-4xl font-bold">{title}</h5>
                <p className="text-white md:w-[500px]">
                    {description.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </p>
            </div>
            <div>
                {iconRef1 && index === 0 && (
                    <Image
                        src={getStrapiMedia(icon.url)}
                        alt={icon.alternativeText || ""}
                        width={200}
                        height={200}
                        loading="eager"
                        className="hidden md:block absolute top-0 -translate-y-20 right-[30%] z-[-1]"
                        ref={iconRef1}
                    />
                )}
                <div className="rounded-3xl overflow-hidden">
                    {mediaType === "video" ? (
                        <LazyLoadVid
                            src={media.url}
                            fallback={media.url}
                            className="w-full md:h-[500px]"
                        />
                    ) : (
                        <Image
                            src={getStrapiMedia(media.url)}
                            alt={media.alternativeText || ""}
                            height={1600}
                            width={1600}
                            className="w-full md:h-[500px] object-contain"
                            loading="eager"
                        />
                    )}
                </div>
            </div>
        </div>
    ) : (
        <div className="relative flex flex-col md:flex-row-reverse justify-between items-center md:items-start md:w-max gap-8 md:gap-20">
            <div
                className={`mt-14 space-y-8 md:max-h-[400px] ${
                    description2 ? "md:flex md:space-x-12" : ""
                }`}
            >
                <div className="space-y-8">
                    <h5 className="text-cyan text-4xl font-bold">{title}</h5>
                    <p className="text-white md:w-[500px] md:max-h-[400px] overflow-hidden">
                        {description.split("\n").map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </p>
                </div>
                {description2 && (
                    <div className="md:!mt-[4.2rem]">
                        <p className="text-white md:w-[500px] md:max-h-[400px] overflow-hidden">
                            {description2}
                        </p>
                    </div>
                )}
            </div>
            <div>
                {/* <Image
                    src={getStrapiMedia(media.url)}
                    alt={media.alternativeText || ""}
                    height={300}
                    width={300}
                    className="w-full md:h-[500px] object-contain"
                    loading="lazy"
                /> */}
                <div className="rounded-3xl overflow-hidden">
                    {mediaType === "video" ? (
                        <LazyLoadVid
                            src={media.url}
                            fallback={media.url}
                            className="w-full md:h-[500px]"
                        />
                    ) : (
                        <Image
                            src={getStrapiMedia(media.url)}
                            alt={media.alternativeText || ""}
                            height={1600}
                            width={1600}
                            className="w-full md:h-[500px] object-contain"
                            loading="eager"
                        />
                    )}
                </div>
                {iconRef2 && index === 2 && (
                    <Image
                        src={getStrapiMedia(icon.url)}
                        alt={icon.alternativeText || ""}
                        width={200}
                        height={200}
                        loading="eager"
                        className="hidden md:block absolute 3xl:-bottom-36 3xl:-right-40 -bottom-20 right-0 z-[0]"
                        ref={iconRef2}
                    />
                )}
            </div>
        </div>
    );
}
